import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import styles from './ThankYou.module.css';
import { DesktopView } from './desktop/CreateParentAccount.desktop';
import { MobileView } from './mobile/CreateParentAccount.mobile';

export const CreateParentAccount = (): JSX.Element => {
  // Redux Hooks

  return (
    <React.Fragment>
      {isMobileOnly ? <MobileView /> : <DesktopView />}
    </React.Fragment>
  );
};
